import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEliminarExamen, setDataSolicitudAgenda } from "./actions";
class ModalEliminarExamen extends React.PureComponent {
  handleClose = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const { onOpen, onSetDataSolicitudAgenda } = this.props;
    onOpen(false, _data, {});
    onSetDataSolicitudAgenda(_data);
  }
  handleEliminar = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const { examen, onOpen, onSetDataSolicitudAgenda } = this.props;

    switch (examen.ExamTypeId) {
      case 1:
        _data.examenesAdicionales = _data.examenesAdicionales.filter((v) => v.Id !== examen.Id);
        onOpen(false, _data, {});
        onSetDataSolicitudAgenda(_data);
        break;
      case 2:
        _data.examenesPsicologicos = _data.examenesPsicologicos.filter((v) => v.Id !== examen.Id);
        onOpen(false, _data, {});
        onSetDataSolicitudAgenda(_data);
        break;
      default:
        _data.baterias = _data.baterias.filter((v) => v.Id !== examen.Id);
        onOpen(false, _data, {});
        onSetDataSolicitudAgenda(_data);
    }
  }
  render() {
    const { examen } = this.props;
    let texto = "batería";
    const articulo = "la";

    switch (examen.ExamTypeId) {
      case 1:
        texto = "prestación médica";
        break;
      case 2:
        texto = "evaluación  psicológica";
        break;
      default:
        break;
    }
    return (
      <Popup
        title={`Eliminar ${texto}`}
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleClose}
        visible={this.props.isOpenModalEliminarExamenes}
        width={500}
        height={200}
        contentComponent={() => (
          <div style={{ textAlign: "center" }} className="modal-delete-mantenedor">
            Al eliminar {articulo}  {texto} se perderán todas sus relaciones con centros.
            <br />
            ¿Quieres eliminar {articulo} {texto} de todas formas?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleClose} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}
const mapStateToProps = (state) => ({
  isOpenModalEliminarExamenes: state.solicitudesAgendaSel.isOpenModalEliminarExamenes,
  examen: state.solicitudesAgendaSel.examen,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  isLoading: state.solicitudesAgendaSel.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  onOpen: (open, data, examen) => dispatch(openCloseModalEliminarExamen(open, data, examen)),
  onSetDataSolicitudAgenda: (data) => dispatch(setDataSolicitudAgenda(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalEliminarExamen);
